// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2W8v6","containerItemsCenter":"Skeleton_containerItemsCenter__iH4jA"};